import { Box, FormHelperText, OutlinedInput } from '@mui/material'
import React from 'react'
import { Control, Controller, FieldError, RegisterOptions, UseControllerReturn } from 'react-hook-form'

type Props = {
  control: Control
  id: string
  label: string
  error: FieldError
  rules?: RegisterOptions
  loadAddress: (value: string) => void
}

function CepField({ control, id, label, error, rules, loadAddress }: Props) {
  return (
    <>
      <FormHelperText style={{ fontSize: '0.938rem' }}>{label}</FormHelperText>
      <Controller
        name={id}
        control={control}
        rules={rules}
        defaultValue=""
        render={({ field: { ref, value, onBlur, ...field } }: UseControllerReturn) => (
          <OutlinedInput
            {...field}
            fullWidth
            inputRef={ref}
            id={id}
            type="text"
            color="success"
            inputProps={{ maxLength: 8 }}
            onBlur={() => {
              loadAddress(value)
              onBlur()
            }}
            error={!!error}
          />
        )}
      />
      <Box height={20}>
        <FormHelperText error style={{ fontSize: '0.938rem' }}>
          {error?.message}
        </FormHelperText>
      </Box>
    </>
  )
}

export default CepField
